import React from "react";
import {Button} from "rsuite";

import './view1.scss'

import MobileImageView1 from "../../../img/landing/mobile-view.svg";
import DesktopImageView1 from "../../../img/landing/desktop-view1.svg";

const View1 = (props) => {

    const handleJumpTo = props.handleJumpTo;
    const handleNext = () => {
        window.location.href = '/new-form'
    }

    return (<>
        <div id='view1' className='view1'>
            <div className={`container-view1  box-cover-view-1 `}>
                <div className={`container-view-1`}>
                    <div className={` content`}>
                        <div
                            className={`  text-content text-large text-large-bolder desktop-text-align-right mb-4 `}>برای
                            تغییر آماده
                            ای؟
                        </div>
                        <div
                            className={` sub-title text-content text-semi-bolder text-medium desktop-text-align-right  `}>چنگال
                            با
                            یک برنامه منعطف و اصــولی تورو به اندام
                            ایده آلت میرسونه.
                        </div>

                        <img src={MobileImageView1} className={'mobile-item gradient-primary'}/>
                        <div
                            className={`text-normal text-bolder  desktop-text-align-right mobile-text-align-center `}>همین
                            حالا مسیر سلامتیت رو شروع کن
                        </div>

                        <div className={` buttons-container `}>
                            <div className={`  button`}>
                                <Button appearance={'ghost'}
                                        loading={false}
                                        onClick={() => handleJumpTo('analysis')}
                                        className={`text-small btn-custom `}
                                        block>
                                    آنالیز رایگان
                                </Button>
                            </div>
                            <div className={`  button `}>
                                <Button appearance={'primary'}
                                        loading={false}
                                        onClick={handleNext}
                                        className={`text-small btn-custom`}
                                        block>
                                    دریافت رژیم
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={` image desktop-item `}>
                    <img src={DesktopImageView1} className={' gradient-primary'}/>
                </div>


            </div>
        </div>
    </>)
}
export default View1;